// Bengali labels for object keys used in the auto-form editor.
export const LABELS = {
  branding: "ব্র্যান্ডিং", name: "নাম", sub: "সাব-টেক্সট", tagline: "ট্যাগলাইন",
  menu: "মেনু", label: "লেবেল", href: "লিংক", navCta: "নেভিগেশন বাটন",
  hero: "হিরো সেকশন", heading: "শিরোনাম", subheading: "উপ-শিরোনাম",
  primaryBtn: "প্রধান বাটন", secondaryBtn: "দ্বিতীয় বাটন", image: "ছবি",
  image1: "ছবি ১", image2: "ছবি ২", photo: "ছবি", badgeTitle: "ব্যাজ শিরোনাম",
  badgeText: "ব্যাজ টেক্সট", captionLabel: "ক্যাপশন লেবেল", captionText: "ক্যাপশন",
  stats: "পরিসংখ্যান", value: "মান", about: "পরিচয় সেকশন", title: "শিরোনাম",
  intro: "ভূমিকা", para1: "অনুচ্ছেদ ১", para2: "অনুচ্ছেদ ২", features: "বৈশিষ্ট্য",
  icon: "আইকন", text: "টেক্সট", why: "কেন শ্রুতি", subtitle: "উপ-শিরোনাম",
  items: "আইটেমসমূহ", desc: "বিবরণ", coursesSection: "পাঠক্রম শিরোনাম",
  facultySection: "শিক্ষক শিরোনাম", gallerySection: "গ্যালারি শিরোনাম",
  testimonialsSection: "প্রশংসা শিরোনাম", eventsSection: "অনুষ্ঠান শিরোনাম",
  admission: "ভর্তি সেকশন", note: "নোট", formTitle: "ফর্ম শিরোনাম",
  formSubtitle: "ফর্ম উপ-শিরোনাম", submitLabel: "সাবমিট বাটন",
  contact: "যোগাযোগ", address: "ঠিকানা", phone: "ফোন", email: "ইমেইল",
  whatsapp: "হোয়াটসঅ্যাপ", hours: "অফিস সময়", mapEmbed: "গুগল ম্যাপ (embed URL)",
  footer: "ফুটার", columns: "কলাম", links: "লিংকসমূহ", socials: "সোশ্যাল লিংক",
  copyright: "কপিরাইট", theme: "থিম", primary: "প্রাইমারি রঙ",
  secondary: "সেকেন্ডারি রঙ", accent: "অ্যাকসেন্ট রঙ", bgMain: "মূল ব্যাকগ্রাউন্ড",
  bgAlt: "বিকল্প ব্যাকগ্রাউন্ড", card: "কার্ড রঙ", textMuted: "হালকা টেক্সট রঙ",
  border: "বর্ডার রঙ", radius: "কোণের গোলাই (px)", headingFont: "শিরোনাম ফন্ট",
  bodyFont: "বডি ফন্ট", seo: "SEO", keywords: "কীওয়ার্ড", description: "বিবরণ",
  age: "বয়স", fees: "ফি", duration: "সময়কাল", featured: "ফিচার্ড",
  type: "ধরন", heading: "শিরোনাম", buttonLabel: "বাটন টেক্সট", buttonHref: "বাটন লিংক",
  overlay: "ওভারলে (0-1)", enabled: "সক্রিয়", showDelay: "বিলম্ব (সেকেন্ড)",
  frequency: "কত ঘন ঘন (session/once/always)", excerpt: "সংক্ষিপ্তসার",
  content: "মূল লেখা", tags: "ট্যাগ", author: "লেখক", slug: "স্লাগ", seoTitle: "SEO টাইটেল",
  status: "স্ট্যাটাস", role: "পদবি", bio: "পরিচিতি", quote: "উক্তি",
  rating: "রেটিং", date: "তারিখ", venue: "স্থান", regLink: "রেজিস্ট্রেশন লিংক",
  caption: "ক্যাপশন", category: "বিভাগ", alt: "Alt টেক্সট", primaryBtnColor: "রঙ",
};

export function labelFor(key) {
  return LABELS[key] || key;
}
